module.exports = __webpack_public_path__ + "static/img/customer-code.4cdc50f.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/customer-code.png
// module id = Jx6J
// module chunks = 1